import $ from 'jquery' // jQuery

// import { Autoplay, Controller, EffectFade, Navigation, Pagination, Swiper } from 'swiper'
// Swiper.use([Autoplay, Controller, EffectFade, Navigation, Pagination]) // Swiper宣言
// その他、Swiperで使う機能があったら上に追加で宣言する
// A11y, Autoplay, Controller, EffectCoverflow, EffectCube, EffectFade, EffectFlip, HashNavigation, History, Keyboard, Lazy, Mousewheel, Navigation, Pagination, Parallax, Scrollbar, Thumbs, Virtual, Zoom,

if (document.getElementById('page-top')) {
  pageTop()
}

function pageTop() {}

/*
##     ##  #######  ########     ###    ##
#### #### ##     ## ##     ##  ##   ##  ##
## ### ## ##     ## ##     ## ##     ## ##
##     ## ##     ## ##     ## ######### ##
##     ##  #######  ########  ##     ## ########
*/
$('.js-topVoiceModal-open').on('click', function () {
  const index = $(this).index()
  openModal($('.js-topVoiceModal-item').eq(index))
  return false
})

let scrollTop
// モーダル開く
function openModal(el) {
  console.log('modal open: ' + el.index())
  let elModal = el.children('.js-topVoiceModal')
  let elModalContent = elModal.children('.js-topVoiceModal-content')
  scrollTop = $(window).scrollTop()
  elModal.addClass('active')
  elModal.scrollTop(0)
  $('body').addClass('modalOn')
  $('body').css({ top: -1 * scrollTop })
  if (navigator.userAgent.indexOf('iPhone') !== -1 || navigator.userAgent.indexOf('iPad') !== -1) {
    for (let i = 0; i < elModalContent.length; i++) {
      elModalContent[i].addEventListener(
        'touchmove',
        function (e) {
          const scroll = elModalContent.scrollTop
          const range = elModalContent.scrollHeight - elModalContent.offsetHeight - 1
          if (scroll < 1) {
            e.preventDefault()
            elModalContent.scrollTop = 1
          } else if (scroll > range) {
            e.preventDefault()
            elModalContent.scrollTop = range
          }
        },
        { passive: false }
      )
    }
  }
}

// モーダル閉じる
$('.js-topVoiceModal-close').on('click', function () {
  closeModal($(this).closest('.js-topVoiceModal'))
})
$('.js-topVoiceModal').on('click', function () {
  closeModal($(this))
})
$('.js-topVoiceModal-content').on('click', function (e) {
  e.stopPropagation()
})
function closeModal(el) {
  el.removeClass('active')
  $('body').removeClass('modalOn')
  $('body').css('top', '')
  $(window).scrollTop(scrollTop)
}
